import React from "react";
import { Row, Accordion, Button, Card } from "react-bootstrap";
import { Link } from "react-router-dom";

const Category = props => {
  const data = props.data;
  const children = data.children || [];
  const posts = data.posts || [];

  return (
    <div>
      <Accordion>
        <Card>
          <Card.Header style={{ borderRadius: 10 }}>
            <Accordion.Toggle as={Button} variant="link" eventKey="0">
              {data.title} {` (${children.length + posts.length} مورد)`}
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              {posts.map(post => (
                <li
                  style={{
                    marginTop: 5,
                    marginBottom: 5,
                    borderBottom: "1px solid #eee",
                  }}>
                  <Link to={`/help-my-lib/${post.id}`}>{post.title}</Link>
                </li>
              ))}
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};
export default props => {
  const { sidebar_title, data } = props;
  return (
    <div className="sideBarWrapper">
      <Row className="justify-content-center">
        <h4>{sidebar_title}</h4>
      </Row>
      <hr />
      <Row>
        <div className="custom-accordion " style={{ width: "100%" }}>
          <ul style={{ padding: 0 }}>
            {data.map(cat => (
              <Category data={cat} />
            ))}
          </ul>
        </div>
      </Row>
    </div>
  );
};
